import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../lib/auth";

const MaintenanceCtx = createContext({ status: null, refresh: async () => {} });

export function MaintenanceProvider({ children }) {
  const { user, endForMaintenance } = useAuth();
  const [status, setStatus] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/maintenance/status");
      setStatus(data);
      if (data.active && user?.role === "customer") {
        await endForMaintenance();
      }
    } catch {
      // A failed availability check must never interrupt a working session.
    }
  }, [endForMaintenance, user?.role]);

  useEffect(() => {
    refresh();
    if (!user || user.role !== "customer") return undefined;
    const interval = window.setInterval(refresh, 60000);
    return () => window.clearInterval(interval);
  }, [refresh, user]);

  return (
    <MaintenanceCtx.Provider value={{ status, refresh }}>
      {children}
    </MaintenanceCtx.Provider>
  );
}

export const useMaintenance = () => useContext(MaintenanceCtx);